import {ServiceItemViewModel} from './ServiceItemModel'

export class CreateTransactionViewModel {

      TransactionId : number;
      paymentRequestId : number;
      CustomerId : string;
      custTrackingNo : string ;
      PartyId : string;
      RecurringFlag : string;
      Product : string;
      ChargeAmt  : number;
      CreateDate : Date;
      LastUpdateDate : Date;
      LogRecId  : number;
      AFSTransactionId : string;
      TrackingNo : string; 
      LenderId  : string;
      LenderName  : string;
      LoanId  : string;
      VendorId  : string;
      VendorCompany  : string;
      VendorContact  : string;
      VendorAddressStreet  : string;
      VendorAddressCity  : string;
      VendorAddressState  : string;
      VendorAddressZip  : string;
      VendorTaxId  : string;
      VendorTinCode  : string;
      VendorContactPhone  : string;
      VendorContactEmail  : string;
      VendorWebsiteURL  : string;
      InvoiceNo  : string;
      ServiceCode  : string;
      ServiceDescription  : string;
      ServiceCharge  : string;
      ServiceDate  : string;
      PreApprovedAccountId  : string;
      PayeeType  : string;
      PayeeCompany  : string;
      PayeeNameFirst  : string;
      PayeeNameLast  : string;
      PayeeEmail  : string;
      PayeePhone  : string;
      PropertyAddressStreet  : string;
      PropertyAddressCity  : string;
      PropertyAddressState  : string;
      PropertyAddressZip  : string;
      SendPayeeEmail  : string;
      remitToId  : string;
      SettlementRequired  : string;
      settleDate  : string;
      CompletionRequired : string;
      remitDate  : Date;
      CustTransactionId  : string;      
      ContractId : string;
      paymentLink : string;
      completionDT : Date;
      expiresDT : Date;
      ClientPreferredResponseIdentifier: string;
      public ServiceItems: ServiceItemViewModel;
}

